import React, { useContext } from 'react'
import Draggable from 'react-draggable'

import { AppStateContext } from '../AppStateContext'
import Panel from '../../../elem/panel/Panel'
import { detailPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import WellDetailPanelHeader from './WellDetailPanelHeader'
import DataContextProvider from './DataContext'
import DetailTabs from './DetailTabs'
import WellDetails from './WellDetails'
import ScreenDetails from './ScreenDetailList'
import SampleDetails from './SampleDetailList'
import DetailChart from './DetailChart'
import TimeWindowDropdown from './TimeWindowDropdown'
import ExpandableDetailChart from './ExpandableDetailChart'

const Detail = () => {
    const { detailState } = useContext(AppStateContext)
    const visible = detailState.well.visible
    return (
        <DataContextProvider>
            {/* we cannot define the expanded chart inside of the detailPanelWrapper because
             the css display: '....' of the <Draggable /> screws things up */}
            <ExpandableDetailChart visible={visible} />
            <Draggable
                bounds="parent"
                handle=".wellDetailPanelHeader"
                positionOffset={{ x: '.75rem', y: '.75rem' }}
            >
                <div
                    className={`column is-4-desktop is-half-tablet is-full-mobile detailPanelWrapper ${
                        !visible ? 'is-invisible' : ''
                    }`}
                >
                    <Panel panelClassConfig={panelClassConfig()}>
                        <WellDetailPanelHeader />
                        <div className="wellDetailWrapper">
                            <DetailChart />
                            <TimeWindowDropdown />
                            <DetailTabs />
                            <WellDetails />
                            <SampleDetails />
                        </div>
                    </Panel>
                </div>
            </Draggable>
        </DataContextProvider>
    )
}

export default Detail
